import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "confirm"
}

import order from "@/api/order";
import { useStore } from "vuex";
interface _dataList {
  //数据
  data: string;
  //创建时间
  createTime: string;
  // 接收状态 true为接手 false为发送
  correlationState: boolean;
  //文件路径
  link: string;
  //文件类型 0图片 1视频 2文件
  linkType: number;
  //文件名称
  fileName: string;
  //状态码
  status: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Text',
  props: {
    item: null,
    rid: null
  },
  setup(__props: any) {

const props = __props as {
  item: _dataList;
  rid: string;
};


const $store = useStore();
const confirm = () => order.endOrder(Number(props.rid));

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(props.item.data) + " ", 1),
    (
      props.item.status == 11 &&
      __props.item.correlationState &&
      _unref($store).state.talk.serviceExpireTime[props.rid] != 11
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})